export default "__VITE_ASSET___Pd0V8Lc__"